import { createRouter, createWebHistory } from 'vue-router'
import Create from '../views/Create.vue'
import Status from '../views/Status.vue'
import AllStatus from '../views/AllStatus.vue'
import Dashboard from '../components/Dashboard.vue'
import PageResults from '../components/PageResults.vue'

const routes = [
  {
    path: '/results/:crawlId',
    name: 'dashboard',
    component: Dashboard,
    props: true,
    children: [
      {
        path: 'products',
        component: Status,
        name: 'productResults',
        props: true
      },
      {
        path: 'pages',
        component: PageResults,
        name: 'pageResults',
        props: true
      }
    ]
  },
  {
    path: '/create',
    name: 'createDashboard',
    component: Dashboard,
    props: true,
    children: [
      {
        path: ':crawlId',
        component: Create,
        name: 'createFromCrawl',
        props: true
      },
      {
        path: '',
        component: Create,
        name: 'create',
        props: true
      },
    ]
  },
  {
    path: '/status/:crawlId',
    name: 'status',
    component: Status,
    props: true
  },
  {
    path: '/allstatus',
    name: 'allstatus',
    component: AllStatus
  },
  {
    path: '/:someVar(.*)',
    redirect: '/create' 
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
